module.exports = __webpack_public_path__ + "9e70aaad4570c392fd88e9ed67117d77.MP3";